import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '../../context/Auth';

const Logout = () => {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  useEffect(() => {
    signOut().then(() => navigate('/'));
  }, []);

  return <></>;
};

export default Logout;
